/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SiteNavItem_navigationModule = {
    readonly imageLink: string | null;
    readonly name: string | null;
    readonly linkData: {
        readonly " $fragmentRefs": FragmentRefs<"SeoLink_linkData">;
    };
    readonly isHighlighted: boolean | null;
    readonly items: ReadonlyArray<{
        readonly serviceId: string | null;
        readonly name: string | null;
        readonly column: string | null;
        readonly items: ReadonlyArray<{
            readonly serviceId: string | null;
            readonly name: string | null;
            readonly linkData: {
                readonly " $fragmentRefs": FragmentRefs<"SeoLink_linkData">;
            };
        } | null> | null;
    } | null> | null;
    readonly " $fragmentRefs": FragmentRefs<"SiteNavDropdownContent_navigationModule">;
    readonly " $refType": "SiteNavItem_navigationModule";
};
export type SiteNavItem_navigationModule$data = SiteNavItem_navigationModule;
export type SiteNavItem_navigationModule$key = {
    readonly " $data"?: SiteNavItem_navigationModule$data;
    readonly " $fragmentRefs": FragmentRefs<"SiteNavItem_navigationModule">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "linkData",
  "storageKey": null,
  "args": null,
  "concreteType": "LinkData",
  "plural": false,
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SeoLink_linkData",
      "args": null
    }
  ]
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "SiteNavItem_navigationModule",
  "type": "NavigationModule",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "imageLink",
      "args": null,
      "storageKey": null
    },
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isHighlighted",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "items",
      "storageKey": null,
      "args": null,
      "concreteType": "NavigationTopLevel",
      "plural": true,
      "selections": [
        (v2/*: any*/),
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "column",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "items",
          "storageKey": null,
          "args": null,
          "concreteType": "NavigationItem",
          "plural": true,
          "selections": [
            (v2/*: any*/),
            (v0/*: any*/),
            (v1/*: any*/)
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "SiteNavDropdownContent_navigationModule",
      "args": null
    }
  ]
};
})();
(node as any).hash = '7c9b3227baf7a280be5e1293543ecf26';
export default node;
